import { render, staticRenderFns } from "./modalMobil.vue?vue&type=template&id=e2b169b8&"
import script from "./modalMobil.vue?vue&type=script&lang=js&"
export * from "./modalMobil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports